import { MonitoringService } from './MonitoringService';

interface PerformanceMetrics {
  responseTime: number;
  cpuUsage: number;
  memoryUsage: number;
  activeConnections: number;
  queryCount: number;
}

export class PerformanceMonitor {
  private static instance: PerformanceMonitor;
  private metrics: PerformanceMetrics = {
    responseTime: 0,
    cpuUsage: 0,
    memoryUsage: 0,
    activeConnections: 0,
    queryCount: 0
  };

  private constructor() {
    this.startMonitoring();
  }

  public static getInstance(): PerformanceMonitor {
    if (!PerformanceMonitor.instance) {
      PerformanceMonitor.instance = new PerformanceMonitor();
    }
    return PerformanceMonitor.instance;
  }

  private startMonitoring(): void {
    setInterval(() => this.collectMetrics(), 5000);
  }

  private async collectMetrics(): Promise<void> {
    // In a real implementation, collect actual metrics
    this.metrics = {
      responseTime: Math.random() * 100,
      cpuUsage: Math.random() * 100,
      memoryUsage: Math.random() * 100,
      activeConnections: Math.floor(Math.random() * 1000),
      queryCount: Math.floor(Math.random() * 10000)
    };

    if (this.shouldAlertOnMetrics()) {
      this.triggerAlert();
    }
  }

  private shouldAlertOnMetrics(): boolean {
    return (
      this.metrics.responseTime > 1000 ||
      this.metrics.cpuUsage > 80 ||
      this.metrics.memoryUsage > 90
    );
  }

  private triggerAlert(): void {
    const monitoring = MonitoringService.getInstance();
    monitoring.log('warn', 'Performance threshold exceeded', this.metrics);
  }

  public getMetrics(): PerformanceMetrics {
    return { ...this.metrics };
  }
}